import useMatchMedia from './useMatchMedia';
import { ref, onMounted, onUnmounted } from 'vue';

export function useIsMobile() {
  return useMatchMedia('(max-width: 767px)');
}

export function useIsBreakpointSize(size) {
  const isSize = ref(false);

  const handleMediaQueryChange = (event) => {
    isSize.value = event.matches;
  };

  onMounted(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${size}px)`);
    isSize.value = mediaQuery.matches;
    mediaQuery.addListener(handleMediaQueryChange);
  });

  onUnmounted(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${size}px)`);
    mediaQuery.removeListener(handleMediaQueryChange);
  });

  return isSize;
}
